export const DEFAULT_GROUP_BY_INDEX = 1;
export const groupByOptions = [
    {
        label: 'Hour',
        value: 'hour',
    },
    {
        label: 'Day',
        value: 'day',
    },
    {
        label: 'Month',
        value: 'month',
    },
];
